import { AssetsPrivateUseModel } from "@interfaces/index";

export const getPrivateUseValue = (
  asset: AssetsPrivateUseModel,
  defaultValue = "",
) =>
  (asset.mileagePrivateUse ? (asset.mileagePrivateUse * 100).toFixed(2) : "") ||
  (asset.privateUse ? (asset.privateUse * 100).toFixed(2) : "") ||
  defaultValue;
